import { getPlaces, getShortestPath } from '@/api/route-links'
import { make } from 'vuex-pathify'

const state = {
  model: {
    from: '',
    to: '',
    via: ''
  },
  places: {
    pending: false,
    data: []
  },
  shortestPath: {
    pending: false,
    error: null,
    data: []
  }
}

const mutations = make.mutations(state)

const actions = {
  async fetchPlaces({ commit }) {
    commit('SET_PLACES', { pending: true, data: [], error: null })
    const { data } = await getPlaces()
    commit('SET_PLACES', {
      pending: true,
      data: data.map(x => ({
        ...x,
        lat: x.lat,
        lng: x.lon
      })),
      error: null
    })
  },

  async getShortestPath({ commit }, payload) {
    commit('SET_SHORTEST_PATH', { pending: true, data: [], error: null })
    try {
      const { data } = await getShortestPath(payload)
      commit('SET_SHORTEST_PATH', {
        data,
        error: !data.length && 'Ingen data hittades på din sökning...',
        pending: false
      })
    } catch (err) {
      const payload = {
        data: [],
        error: null,
        pending: false
      }
      if (err.response.status === 404) {
        payload.error = 'Ingen data hittades på din sökning...'
      } else {
        payload.error = 'Ett fel uppstod, försök igen...'
      }
      commit('SET_SHORTEST_PATH', payload)
    }
  }
}

const getters = {
  routePath: state =>
    state.shortestPath.data.reduce((acc, place) => {
      if (place.fromLat) {
        acc.push({
          place: place.placeStart,
          lat: place.fromLat,
          lng: place.fromLon
        })
      }

      if (place.toLat) {
        acc.push({
          place: place.placeEnd,
          lat: place.toLat,
          lng: place.toLon
        })
      }
      return acc
    }, [])
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
